module.exports = __webpack_public_path__ + "img/icon-sb-build-own-sectional-48x48.133cb3b.svg";